import {GNWP_SOURCES} from "../../../../../../app-react/services/gnwp/gnwp-consts";
import USBaseRegulation from "../us/us_base_regulation";
import {REGULATION_CODE_TYPES} from "../../regulation_const";

export default class MichiganRegulation extends USBaseRegulation {
    static CLASS = 'MichiganRegulation';

    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.MICHIGAN;
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return this.serviceFactory.orbitComponentRenderService().showLocationPopup({});
    }

    shouldRefreshTokenOnAppOpen(){
        return true;
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        if(source !== GNWP_SOURCES.MEMBERSHIP) {
            return Promise.resolve();
        }

        return this.stepsBeforeOpenLoginAndRegistration();
    }

    supportWithdrawOnlyFromReal() {
        return true;
    }

    isDeviceDetectionEnabled() : boolean {
        return true;
    }
}